import React, { useEffect } from "react"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { Optional } from "../../types";
import { SmartFormContext } from "./SmartFormContext";

type SmartFormProps<T> = {
  className?: string;
  values?: T;
  defaultValues?: T;
  formRef?: any;
  onChange?: (values: T) => void;
  onSubmit?: (values: T) => void;
  children: React.ReactNode;
  schema: any;
  errors?: {
    [Property in keyof T]?: string[]
  }
}

const SmartForm = <T=unknown,>(props: SmartFormProps<Optional<T>>) => {
  const {
    className = "",
    values,
    defaultValues,
    formRef,
    children,
    schema,
    onSubmit,
    onChange,
  } = props;

  const methods = useForm({
    // @ts-ignore
    defaultValues,
    mode: "onSubmit",
    values,
    ...(schema ? {
      resolver: yupResolver(schema)
    } : {}),
  });
  const errors = methods.formState.errors;
  const { handleSubmit, reset, watch } = methods;

  useEffect(() => {
    const subscription = watch((values) => {
      if (onChange) onChange(values as Optional<T>);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (formRef) {
      formRef.current = {
        handleSubmit: handleSubmit(onSubmit),
        reset,
        methods: methods
      }
    }
  }, []);


  return (
    <SmartFormContext.Provider value={{ methods, errors }}>
      <form onSubmit={handleSubmit(onSubmit)} className={`${className}`}>
        {children}
      </form>
    </SmartFormContext.Provider>
  );
}

export default SmartForm;